import { useEffect, useRef } from "react";

const TEXT =
  "The moment you took your first breath, the planets froze into a pattern unique to you — a map most people never learn to read. Your birth chart decodes that pattern: where your purpose is hiding, why certain people feel like home and others like lessons, when your career finally clicks into place, and which seasons of your life are for building versus for healing. It isn't prediction. It's permission — to stop guessing and start moving with the timing you were actually given.";

const WORDS = TEXT.split(" ");

export const Intro = () => {
  const paraRef = useRef(null);

  useEffect(() => {
    if (!window.gsap || !window.ScrollTrigger || !paraRef.current) return;
    const gsapLib = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    gsapLib.registerPlugin(ScrollTrigger);

    const words = paraRef.current.querySelectorAll(".intro-word");
    gsapLib.to(words, {
      opacity: 1,
      color: "#E8C27A",
      stagger: { each: 0.9 / words.length },
      ease: "none",
      scrollTrigger: {
        trigger: paraRef.current,
        start: "top 85%",
        end: "bottom 55%",
        scrub: true,
      },
    });
  }, []);

  return (
    <section id="intro" className="cosmic-section max-w-4xl mx-auto text-center">
      <p className="reveal cosmic-eyebrow text-sm mb-5">Why Your Chart Matters</p>
      <h2 className="reveal font-display text-3xl sm:text-4xl lg:text-5xl leading-tight mb-8">
        Everything that's happened to you was already written in the sky.
      </h2>
      <p ref={paraRef} data-testid="intro-paragraph" className="text-lg md:text-xl leading-relaxed font-light">
        {WORDS.map((word, i) => (
          <span key={i} className="intro-word mr-[0.3em] inline-block" style={{ color: "#6b6584", opacity: 0.4 }}>
            {word}
          </span>
        ))}
      </p>
    </section>
  );
};
